module.exports = __webpack_public_path__ + "static/media/subGoogle3.bac36d54.png";